import { HTMLAttributes, ReactNode } from "react";
import { cn } from "./lib/utils";

export function HeaderCardTitle({
  title,
  children,
  className,
}: { children?: ReactNode; title?: string } & HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("px-4 py-2", className)}>
      {title && <p className="text-sm font-semibold">{title}</p>}
      {children && children}
    </div>
  );
}

export function HeaderCard({
  title,
  children,
  className,
  contentClassName,
}: { title: ReactNode; children: ReactNode; contentClassName?: string } & Omit<
  HTMLAttributes<HTMLDivElement>,
  "title"
>) {
  return (
    <div className={cn("flex flex-col rounded-xl", className)}>
      <div className="bg-zinc-100 rounded-tr-xl rounded-tl-xl border-b border-r border-l border-t border-neutral-300">
        {title}
      </div>
      <div
        className={cn(
          "bg-white rounded-bl-xl rounded-br-xl border-r border-l border-b border-neutral-300",
          contentClassName
        )}>
        {children}
      </div>
    </div>
  );
}
